import {
  BOX_SHADOW_FIELDS,
  GRAY_300,
  GRAY_400,
  PRIMARY_COLOR,
  PRIMARY_COLOR_TEXT,
  WHITE_COLOR,
} from "../../utils/colors";
import { appendAiCompetitorsTrackingQuery } from "./aiCompetitorsLandingQuery";
import { pickLocalizedValue } from "../../utils/i18nLanguage";

export const AI_COMPETITORS_STEP_URL = "url";
export const AI_COMPETITORS_STEP_ANALYZING = "analyzing";
export const AI_COMPETITORS_STEP_COMPETITORS = "competitors";
export const AI_COMPETITORS_STEP_SEARCHING = "searching";
export const AI_COMPETITORS_STEP_RESULTS = "results";

export const AI_COMPETITORS_RTDB_ROOT = "insightsCompetitorSessions";
export const AI_COMPETITORS_ADS_PREVIEW_MIN = 10;
export const AI_COMPETITORS_ADS_PREVIEW_MAX = 30;
export const AI_COMPETITORS_ADS_CENSOR_RATIO = 0.4;
export const AI_COMPETITORS_ADS_UNLOCKED_MAX = 15;
export const AI_COMPETITORS_SESSION_CACHE_TTL_MS = 14 * 24 * 60 * 60 * 1000;
export const AI_COMPETITORS_MAX_COMPETITORS = 8;

export const AI_COMPETITORS_ERROR_INVALID_URL = "invalid_url";
export const AI_COMPETITORS_ERROR_NO_COMPETITORS = "no_competitors";
export const AI_COMPETITORS_ERROR_WEBSITE_BLOCKED = "website_blocked";

export const AI_COMPETITORS_CAL_NAMESPACE = "insightsCompetitorMagnet";
export const AI_COMPETITORS_CAL_LINK_ES = "team/adle/adle-consultoria";
export const AI_COMPETITORS_CAL_LINK_EN = "team/adle/adle-live-demo";
export const AI_COMPETITORS_CAL_BOOKING_SUCCESS_ACTIONS = [
  "bookingSuccessful",
  "bookingSuccessfulV2",
];
export const AI_COMPETITORS_BASE_PATH = "/ai-competitors";
export const AI_COMPETITORS_FOUND_PATH = `${AI_COMPETITORS_BASE_PATH}/found`;
export const AI_COMPETITORS_SCHEDULE_PATH = `${AI_COMPETITORS_BASE_PATH}/schedule`;
export const AI_COMPETITORS_AGENDA_PATH = `${AI_COMPETITORS_BASE_PATH}/agenda`;
export const AI_COMPETITORS_THANKS_PATH = `${AI_COMPETITORS_BASE_PATH}/thanks`;

export const getAiCompetitorsFoundPath = (sessionId = "") => {
  const id = String(sessionId || "").trim();
  if (!id) return AI_COMPETITORS_FOUND_PATH;
  return `${AI_COMPETITORS_FOUND_PATH}?brand=${encodeURIComponent(id)}`;
};

export const getAiCompetitorsSchedulePath = (sessionId = "") => {
  const id = String(sessionId || "").trim();
  if (!id) return AI_COMPETITORS_SCHEDULE_PATH;
  return `${AI_COMPETITORS_SCHEDULE_PATH}?brand=${encodeURIComponent(id)}`;
};
export const AI_COMPETITORS_THANKS_URL_EN = "https://adle.ai/demo-thank-you/";
export const AI_COMPETITORS_THANKS_URL_ES =
  "https://adle.ai/es/demo-thank-you/";

export const getAiCompetitorsCalLink = (language = "en") =>
  pickLocalizedValue(language, {
    en: AI_COMPETITORS_CAL_LINK_EN,
    es: AI_COMPETITORS_CAL_LINK_ES,
  });

export const getAiCompetitorsThanksUrl = (language = "en") => {
  const base = pickLocalizedValue(language, {
    en: AI_COMPETITORS_THANKS_URL_EN,
    es: AI_COMPETITORS_THANKS_URL_ES,
  });
  return appendAiCompetitorsTrackingQuery(base);
};

export const AI_COMPETITORS_ENDPOINTS = [
  "createInsightsCompetitorSession",
  "analyzeInsightsCompetitorWebsite",
  "searchInsightsCompetitorAds",
  "updateInsightsCompetitorSession",
];

export const AI_COMPETITORS_OUTLINED_INPUT_SX = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "9px !important",
    backgroundColor: WHITE_COLOR,
    boxShadow: BOX_SHADOW_FIELDS,
    "& fieldset": {
      borderRadius: "9px !important",
      borderColor: GRAY_300,
    },
    "&:hover fieldset": {
      borderColor: GRAY_400,
    },
    "&.Mui-focused fieldset": {
      borderColor: `${PRIMARY_COLOR} !important`,
      borderWidth: "1.5px",
    },
    "&.Mui-error fieldset": {
      borderColor: "error.main",
    },
    "&.Mui-error.Mui-focused fieldset": {
      borderColor: "error.main !important",
    },
    "& input": {
      padding: "11px 14px",
      fontSize: "14px",
      color: PRIMARY_COLOR_TEXT,
      lineHeight: 1.5,
    },
  },
};

export const AI_COMPETITORS_PRIMARY_BUTTON_SX = {
  height: 48,
  width: "100%",
  borderRadius: "12px !important",
  textTransform: "none",
  fontSize: 14,
  fontWeight: 500,
  boxShadow: "none",
  whiteSpace: "normal",
  "&:hover": {
    boxShadow: "none",
    opacity: 0.9,
  },
};
